import { ComponentRef, Component } from "@angular/core";
import { IModalDialog, IModalDialogButton, IModalDialogOptions } from "ngx-modal-dialog";

@Component({
    selector: 'app-some',
  templateUrl: './modal-cancel-component-error.html',
})

export class CancelErroModalComponent implements IModalDialog {
    constructor() {}


    dialogInit(reference: ComponentRef<IModalDialog>,  options: Partial<IModalDialogOptions<any>>) {
        //  nenhum processamento necessário
    }
}

